import React from 'react';
import './Achievements.css';
import SectionHeader from '../../components/SectionHeader/SectionHeader';

const Achievements = () => {
  const achievements = [
    {
      title: 'Renovation of Primary Healthcare Centers',
      description: 'Several primary healthcare facilities were renovated and equipped to provide better health services across all wards.',
      date: 'March 2024',
    },
    {
      title: 'Construction of Rural Roads',
      description: 'Over 30 kilometers of rural roads constructed to improve transportation and access to farmlands.',
      date: 'August 2023',
    },
    {
      title: 'Scholarship Awards',
      description: '150 students received educational scholarships to support higher education across Nigeria.',
      date: 'January 2024',
    },
  ];

  return (
    <div className="achievements">
      <SectionHeader title="Our Achievements" subtitle="See our milestone accomplishments over the years" />
      <div className="achievements-list">
        {achievements.map((item, index) => (
          <div className="achievements-card" key={index}>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            <span className="achievements-date">{item.date}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Achievements;